module.exports = __webpack_public_path__ + "images/locator/marker_active-82c36934.svg";